import { z } from 'zod';

import { defineService } from '@@api/lib/defineService';
import {
    BreakingNews,
    NewBreakingNews,
    UnityBreakingNews,
} from '@@api/services/breakingnews/schemas';
import {
    deserializeBreakingnews,
    serializeBreakingnews,
    serializeNewBreakingnews,
} from '@@api/services/breakingnews/transformers';
import config from '@@config';

export const breakingnewsService = defineService(
    (defineEndpoint) => ({
        breakingnews: {
            get: defineEndpoint({
                method: 'GET',
                path: '/breakingnews/:id',
                pathParams: z.object({
                    id: UnityBreakingNews.shape.id,
                }),
                responses: {
                    200: UnityBreakingNews.transform(deserializeBreakingnews),
                },
            }),
            put: defineEndpoint({
                method: 'PUT',
                path: '/breakingnews/:id',
                pathParams: z.object({
                    id: UnityBreakingNews.shape.id,
                }),
                body: BreakingNews.transform(serializeBreakingnews),
                responses: {
                    200: UnityBreakingNews.transform(deserializeBreakingnews),
                },
            }),
            post: defineEndpoint({
                method: 'POST',
                path: '/breakingnews',
                body: NewBreakingNews.transform(serializeNewBreakingnews),
                responses: {
                    201: UnityBreakingNews.transform(deserializeBreakingnews),
                },
            }),
            delete: defineEndpoint({
                method: 'DELETE',
                path: '/breakingnews/:id',
                pathParams: z.object({
                    id: BreakingNews.shape.id,
                }),
                responses: {
                    204: z.never(),
                },
            }),
        },
    }),
    {
        baseUrl: config.apiEnvVars.breakingnewsUrl,
    },
);
